import React from "react";
import {
  AboutSection,
  ArticlesSection,
  ContactSection,
  HeroSection,
  InterestsSection,
  Page,
  ProjectsSection,
  Seo,
  ResumeSection,
} from "gatsby-theme-portfolio-minimal";


export default function IndexPage() {
  return (
    <>
      <Seo title="Chadiamond.io" />
      <Page useSplashScreenAnimation>
      <HeroSection sectionId="hero" />
        <AboutSection sectionId="about" heading="About Cha'Diamond" />
      </Page>
    </>
  );
}
